/**
 * Ticking countdown to an ISO instant (V2 — S-26 timer, S-21 shield HUD).
 * Returns "hh:mm:ss" (or "mm:ss" with {short}) and floors at zero.
 */
import { useEffect, useState } from "react";

function render(msLeft: number, short: boolean): string {
  const total = Math.max(0, Math.floor(msLeft / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  if (short && h === 0) return `${pad(m)}:${pad(s)}`;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export function useCountdown(expiresAt: string | null, opts: { short?: boolean } = {}): string {
  const short = opts.short ?? false;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!expiresAt) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [expiresAt]);

  if (!expiresAt) return render(0, short);
  return render(new Date(expiresAt).getTime() - now, short);
}
